<template>
  <div class="relative" id="table-page">
    <div id="tableContainer">
      <Table ref="table" stripe :height="isFullScreen ? tableH : ''" :columns="column" class="_dsTable" :data="list" :max-height="tableH" :show-summary="summary" :summary-method="handlerSummary" @on-selection-change="selectChange"  @on-sort-change="sortChange"></Table>
        <div id="pagenation" class="overflow-hidden">
          <div v-if="pageShow" class="pt10" style="float: right;">
            <Page transfer :total="recTot" :page-size-opts="pageSizeOpts" :page-size="pageSize" :current="currentPage" size="small" show-total show-elevator show-sizer @on-change="changepage" @on-page-size-change="changeSize" />
          </div>
        </div>
    </div>
    <filter-card :show="show" scrollId="tableContainer" :custom="custom" @close="closeEven" @filterEvent="filterEvent"></filter-card>
  </div>
</template>
<script>
import { filterCard } from '@/assets/mixins/frame'

export default {
  name: 'DsTable',
  mixins: [filterCard],
  props: {
    summary: {
      type: Boolean,
      default: false
    },
    containerH: {
      type: [String, Number],
      default: 500
    },
    pageShow: {
      type: Boolean,
      default: true
    },
    columns: Array,
    data: Array,
    recTot: {
      type: Number,
      default: 0
    },
    isBack: {
      type: Boolean,
      default: true
    },
    sort: {
      type: Object,
      default: () => {
        return {}
      }
    },
    summaryFunc: Function,
    isFullScreen: {
      type: Boolean,
      default: false
    },
    eles: Array
  },
  data () {
    return {
      list: this.data,
      listCopy: JSON.parse(JSON.stringify(this.data)),
      currentPage: 1,
      pageSize: 40,
      sort_form: this.sort,
      column: this.columns,
      pagenationH: 0,
      tableH: 400,
      pageSizeOpts: [10, 20, 30, 40, 100, 200]
    }
  },
  watch: {
    data: {
      handler (m) {
        this.list = m
        this.listCopy = JSON.parse(JSON.stringify(m))
      },
      deep: true
    },
    columns: {
      handler (n) {
        this.column = n
        this.init()
      }
    }
  },
  activated () {
  },
  mounted () {
    // this.init()
    if (this.isFullScreen) {
      this.$nextTick(() => {
        this.tableH = this.$getTableHeight('card', this.eles)
      })
    }
  },
  methods: {
    init () {
      let layoutSide = document.querySelectorAll('.ivu-layout-sider')[0]
      let tableDistance = layoutSide.clientWidth + 29
      if (this.isFullScreen) {
        this.$nextTick(() => {
          this.tableH = this.$getTableHeight('card', this.eles)
        })
      } else {
        this.pagenationH = document.getElementById('pagenation').clientHeight
        let hjH = 0
        if (this.summary) {
          hjH = 50
        }
        this.tableH = this.containerH - this.pagenationH - hjH
      }
      let filters = this.column && this.column.filter(x => x.filter_type && (!x.options || !x.options.length))
      if (filters && filters.length) this.setColumns(this.column, tableDistance, 29)
    },
    handlerSummary ({ columns, data }) {
      return this.summaryFunc(columns, data)
    },
    filterEvent (obj) {
      this.handleEven(obj, this.column)
      let params = {
        cond_list: this.filteredList,
        sort: this.sort_form,
        page: this.currentPage,
        page_size: this.pageSize
      }
      this.$emit('getRequestParams', params)
    },
    changeFrontPage (index) {
      // 当前页码
      this.currentPage = index
      let _start = (index - 1) * this.pageSize
      let _end = index * this.pageSize
      this.list = this.listCopy.slice(_start, _end)
    },
    pageFrontSize (index) {
      let _start = (this.currentPage - 1) * index
      let _end = this.currentPage * index
      this.list = this.listCopy.slice(_start, _end)
      // 当前展示条数
      this.pageSize = index
    },
    changeBackPage (index) {
      this.currentPage = index
      let params = {
        cond_list: this.filteredList,
        sort: this.sort_form,
        page: this.currentPage,
        page_size: this.pageSize
      }
      this.$emit('getRequestParams', params)
    },
    changeBackSize (index) {
      this.pageSize = index
      let params = {
        cond_list: this.filteredList,
        sort: this.sort_form,
        page: this.currentPage,
        page_size: this.pageSize
      }
      this.$emit('getRequestParams', params)
    },
    // 后台分页删除
    changepage (index) {
      this.isBack ? this.changeBackPage(index) : this.changeFrontPage(index)
    },
    changeSize (index) {
      this.isBack ? this.changeBackSize(index) : this.pageFrontSize(index)
    },
    selectChange (select) {
      this.$emit('on-select-change', select)
    },
    sortChange (c) {
      this.currentPage = 1
      this.sort_form = { key: c.key, order: c.order }
      let params = {
        cond_list: this.filteredList,
        sort: this.sort_form,
        page: this.currentPage,
        page_size: this.pageSize
      }
      this.$emit('getRequestParams', params)
    }
  }
}
</script>
<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/dstable/DsTable.vue